import { gql } from '@apollo/client';
import ErrorResultFragment from "../fragments/ErrorResult";
import OrderGroup from "../fragments/OrderGroup";

const DeleteItemInBasketGroup = gql`
  mutation DeleteItemInBasketGroup($shoppingCartItemId: ID!) {
    shoppingCartContext {
      deleteItem(shoppingCartItemId: $shoppingCartItemId) {
        errorResult {
          ...ErrorResultFields
        }
        success
        result {
          groups {
            ...OrderGroupFragment
          }
        }
      }
    }
  }
  ${OrderGroup}
  ${ErrorResultFragment}
`;

export default DeleteItemInBasketGroup;
